import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import LandingPageContainer from '~/features/landing-page'
import jsonLd from '../public/schema.json'

const Homepage: FC = () => {
  const { t } = useTranslation()
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <HeadMetaTags
        title={`${t('meta:home:meta_title')}`}
        description={`${t('meta:home:meta_description')}`}
      />
      <LandingPageContainer />
    </>
  )
}

export default withTranslateProvider(Homepage)
